"use strict";

import Common from "../Common";
import PalettePanel from "../ui/overlays/PalettePanel";
import MagicPencil from "./MagicPencil";
import ColourPencil from "./ColourPencil";

//===================================================
//
// Constructor
//
//===================================================

/**
 * @constructor
 */
function Pencil() {
    // Attributes.
    this._drawLayer = null;
    this._magicPencil = null;
    this._colourPencil = null;
    this._paletteItem = null;
    this._curPencil = null;
    this._audio = null;
}
export default Pencil;
//module.exports = Pencil;
Pencil.prototype.constructor = Pencil;


//===================================================
//
// Public
//
//===================================================

Pencil.prototype.init = function (drawLayer) {
    this._drawLayer = drawLayer;

    // Magic pencil.
    this._magicPencil = new MagicPencil();
    this._magicPencil.init(drawLayer);

    // Colour pencil.
    this._colourPencil = new ColourPencil();
    this._colourPencil.init(drawLayer);

    // Set initial pencil.
    this._curPencil = this._colourPencil;
    this._curPencil.colour = Common.assets.getJSON("config").palettePanel.pages[0][0];
    this._paletteItem = this._curPencil.colour;

    // Signals.
    Common.game.scene.palettePanel.signals.onColourChanged.add(this._onColour_Changed, this);
};


//===================================================
//
// Private
//
//===================================================

Pencil.prototype._draw = function (from, to) {
    // TEST: DYN_OUT:
    Common.game.canvas.drawLayer._dynOutlineContext.beginPath();
    Common.game.canvas.drawLayer._dynOutlineContext.strokeStyle = "black";
    Common.game.canvas.drawLayer._dynOutlineContext.lineWidth = this._curPencil.LINE_THICKNESS;
    Common.game.canvas.drawLayer._dynOutlineContext.lineJoin = "round";
    Common.game.canvas.drawLayer._dynOutlineContext.moveTo(from.x, from.y);
    Common.game.canvas.drawLayer._dynOutlineContext.lineTo(to.x, to.y);
    Common.game.canvas.drawLayer._dynOutlineContext.closePath();
    Common.game.canvas.drawLayer._dynOutlineContext.stroke();
};

Pencil.prototype._stopAudio = function () {
    this._audio.howl.stop(this._audio.id);
    this._audio = null;
};


//===================================================
//
// Events
//
//===================================================

Pencil.prototype.onDrawBegan = function (point) {
    this._curPencil.onDrawBegan(point);
    // TEST: DYN_OUT:
    this._draw(point, new PIXI.Point(point.x + 0.1, point.y + 0.1));
};

Pencil.prototype.onDrawMoved = function (from, to) {
    // Sfx.
    if (this._audio == null)
        this._audio = Common.audio.playSound("sfx_tool_pencil_use_loop_00", {"loop": true});
    TweenMax.killDelayedCallsTo(this._stopAudio);
    TweenMax.delayedCall(0.25, this._stopAudio, null, this);


    this._curPencil.onDrawMoved(from, to);
    // TEST: DYN_OUT:
    this._draw(from, to);
};

Pencil.prototype.onDrawEnded = function () {
    // Sfx.
    TweenMax.killDelayedCallsTo(this._stopAudio);
    if (this._audio != null)
        this._stopAudio();

    // TEST: DYN_OUT:
    Common.game.canvas.drawLayer.dynOutlineData = Common.game.canvas.drawLayer._dynOutlineContext.getImageData(0, 0, Common.game.canvas.WIDTH, Common.game.canvas.HEIGHT);
};

Pencil.prototype._onColour_Changed = function (selection) {
    if (selection.indexOf("#") == 0) {
        this._curPencil = this._colourPencil;
        this._colourPencil.colour = selection;
    }
    else {
        this._curPencil = this._magicPencil;
        this._magicPencil.textureId = selection;
    }

    this._paletteItem = selection;
};


//===================================================
//
// Getters / Setters
//
//===================================================

Object.defineProperty(
    Pencil.prototype,
    "paletteItem",
    {
        get: function () {
            return this._paletteItem;
        }
    });